import Marionette from "backbone.marionette";
import $ from "jquery";

import { heapTrack } from "lib/analytics";

import LoginCodeComponent from "./auth-login-code";
import util from "../../util";

import authLoginTemplate from "../../templates/components/auth/auth-login.jst";

const LoginComponent = Marionette.View.extend({
    template: authLoginTemplate,
    className: "auth-stack",
    ui: {
        loginBtn: "#btn-login",
        password: "#password",
        error: ".js-error",
        errorInvalid: ".js-invalid",
        loginCodeContainer: ".js-code-container",
        orContainer: ".auth-login__or",
        passwordContainer: ".js-password-container",
    },
    events: {
        "click .js-forgot": "onForgotPassword",
        "submit form": "login",
    },
    initialize(opts) {
        this.level = opts.level;
    },
    onForgotPassword(event) {
        event.preventDefault();
        this.trigger("login:forgot");
    },
    onRender() {
        this.ui.password.focus();

        if (this.model.isEmployer()) {
            this.ui.orContainer.hide();
        } else {
            this.loginCodeView = new LoginCodeComponent({
                el: this.ui.loginCodeContainer,
                model: this.model,
                verify: this.model.isVerifyAuthType(),
            });
            this.loginCodeView.render();

            this.listenTo(this.loginCodeView, "code:sent", () => {
                this.ui.passwordContainer.hide();
            });
        }
    },
    showError(msg) {
        this.ui.password.toggleClass("has-error", !!msg);
        this.ui.error.html(msg || "");
        this.ui.errorInvalid.hide();
    },
    login(e) {
        e.preventDefault();

        this.showError();
        const password = this.ui.password.val();
        if (!password) {
            this.showError("This field is required.");
            return;
        }

        this.ui.loginBtn.loading(true);

        const data = {
            ...this.model.toJSON(),
            password,
        };

        $.ajax({
            type: "POST",
            url: this.model.url,
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                heapTrack("Auth - Password Success", {
                    accountType: this.model.getAccountType(),
                });

                setTimeout(() => {
                    window.location = this.model.redirectUrl();
                }, 0);
            })
            .fail((response) => {
                heapTrack("Auth - Password Failure", {
                    accountType: this.model.getAccountType(),
                    status: response.status,
                });

                this.ui.password.toggleClass("has-error", true);
                this.ui.errorInvalid.show();

                setTimeout(() => {
                    util.showLoginChat();
                }, 8000);
            })
            .always(() => {
                this.ui.loginBtn.loading(false);
            });
    },
    serializeData() {
        return {
            handle: this.model.getFormattedHandle(),
            verify: this.model.isVerifyAuthType(),
            locked: this.model.isLockedAuthType(),
            authorizationUrl: this.model.attributes.authorization_url,
        };
    },
});

export default LoginComponent;
